<div class="container-box p-3">
  <!-- Basic Information -->
  <form [formGroup]="form" [formEditablePermission]="form" [class.loading-section]="isSaving$ | async">
    <div class="d-flex align-items-center gap-3">
      <app-ignore-ai-toggle type="rental" view="button" [item]="rental"></app-ignore-ai-toggle>

      <div class="dropdown" dropdown *ngIf="form.get('status') as statusCtrl">
        <button
          class="btn dropdown-toggle"
          dropdownToggle
          [ngClass]="statusCtrl.value === 'ready' ? 'btn-success' : 'btn-danger'"
          i18n-matTooltip
          matTooltip="The Rental Status indicates whether a property is ready or not ready for guests. This can be updated by Service Providers (if using Checklist) or by Administrators and Property Manager users. This does not affect your rental availability."
          matTooltipPosition="above"
        >
          <i class="cs-icon" [ngClass]="statusCtrl.value === 'ready' ? 'cs-icon-check' : 'cs-icon-times'"></i>
          <ng-container *ngIf="statusCtrl.value === 'ready'" i18n>Ready</ng-container>
          <ng-container *ngIf="statusCtrl.value !== 'ready'" i18n>Not Ready</ng-container>
        </button>
        <ul *dropdownMenu class="dropdown-menu">
          <li>
            <a
              class="dropdown-item"
              (click)="statusCtrl.setValue('not-ready')"
              i18n-matTooltip
              matTooltip="Not Available for bookings"
              matTooltipPosition="left"
            >
              <i class="cs-icon cs-icon-times text-sm"></i> <ng-container i18n>Not Ready</ng-container>
            </a>
          </li>
          <li>
            <a
              class="dropdown-item"
              (click)="statusCtrl.setValue('ready')"
              i18n-matTooltip
              matTooltip="Available for bookings"
              matTooltipPosition="left"
            >
              <i class="cs-icon cs-icon-check text-sm"></i> <ng-container i18n>Ready</ng-container>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-6">
        <div class="">
          <h6 class="text-uppercase" i18n>Rental Information</h6>
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="name"
              matInput
              required
              i18n-placeholder
              placeholder="Name"
              autocomplete="off"
            />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('allNumbers')">
              <ng-container i18n>Name cannot be numbers alone.</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
              <ng-container i18n>Name must be at least 2 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
              <ng-container i18n>Name must be at most 140 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').hasError('nameTaken')">
              <ng-container i18n>Name is already in use by another rental.</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('allSpaces')">
              <ng-container i18n>Name cannot be spaces alone.</ng-container>
            </mat-error>
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="nickname"
              matInput
              i18n-placeholder
              placeholder="Nickname"
              autocomplete="off"
            />
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <input
              i18n-matTooltip
              i18n-placeholder
              matTooltip="Create a display name which will be visible to guests on your AdvanceCM website only."
              matTooltipPosition="above"
              matInput
              type="text"
              placeholder="Display Name (Website Name)"
              formControlName="display_name"
            />
            <mat-error *ngIf="form.get('display_name').touched && form.get('display_name').hasError('allSpaces')">
              <ng-container i18n>Display name cannot be spaces alone.</ng-container>
            </mat-error>
          </mat-form-field2>
          <mat-form-field2 class="mat-block">
            <input
              type="email"
              formControlName="email"
              matInput
              required
              i18n-placeholder
              placeholder="AdvanceCM Email"
              autocomplete="off"
            />
            <span matSuffix>@{{ subDomain }}</span>
            <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')">
              <ng-container i18n>Email is required</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('minlength')">
              <ng-container i18n>Email handle must be at least 3 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('email').hasError('emailTaken')">
              <ng-container i18n>Email is already in use by another rental.</ng-container>
            </mat-error>
            <mat-error *ngIf="form.get('email').hasError('rentalEmail')">
              <ng-container i18n>Email is invalid.</ng-container>
            </mat-error>
          </mat-form-field2>
          <div class="row">
            <div class="col-sm-6">
              <app-phone-number-input
                [ctrl]="form.get('phone')"
                i18n-placeholder
                placeholder="Phone"
              ></app-phone-number-input>
            </div>
            <div class="col-sm-6">
              <app-currency-select
                [ctrl]="form.get('currency')"
                i18n-matTooltip
                matTooltip="Adjust the currency for all rates created on this rental. This setting will automatically change the currency on any previously created rates."
              ></app-currency-select>
            </div>
          </div>
          <div class="copy-id-row">
            <strong i18n>Rental Id</strong>: <span>{{ rental.id }}</span>
            <app-copy-icon [content]="rental.id" class="ml-1"></app-copy-icon>
          </div>
          <app-color-boxes [ctrl]="form.get('color')"></app-color-boxes>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="" formGroupName="address">
          <h6 class="text-uppercase" i18n>Rental Location</h6>
          <mat-form-field2 class="mat-block">
            <input
              appGooglePlaces
              (onAddressChange)="onPlaceChange($event)"
              autocomplete="address-1"
              type="text"
              formControlName="address"
              matInput
              i18n-placeholder
              placeholder="Address"
            />
            <mat-error *ngIf="addressForm.get('address').hasError('minlength')">
              <ng-container i18n>Address must be at least 2 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="addressForm.get('address').hasError('maxlength')">
              <ng-container i18n>Address must be at most 140 characters long</ng-container>
            </mat-error>
            <mat-error *ngIf="addressForm.get('address').hasError('allSpaces')">
              <ng-container i18n>Address cannot be spaces alone.</ng-container>
            </mat-error>
          </mat-form-field2>
          <div class="row">
            <div class="col-sm-6">
              <mat-form-field2 class="mat-block">
                <input
                  appGooglePlaces
                  (onAddressChange)="onCityChange($event)"
                  type="text"
                  formControlName="city"
                  matInput
                  required
                  i18n-placeholder
                  placeholder="City"
                />
                <mat-error *ngIf="addressForm.get('city').hasError('minlength')">
                  <ng-container i18n>City must be at least 2 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="addressForm.get('city').hasError('maxlength')">
                  <ng-container i18n>City must be at most 50 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="addressForm.get('city').hasError('allSpaces')">
                  <ng-container i18n>City cannot be spaces alone.</ng-container>
                </mat-error>
              </mat-form-field2>
            </div>

            <div class="col-sm-6">
              <mat-form-field2 class="mat-block">
                <input
                  type="text"
                  formControlName="state"
                  matInput
                  i18n-placeholder
                  placeholder="State / Province / Region"
                />
                <mat-error *ngIf="addressForm.get('state').hasError('minlength')">
                  <ng-container i18n>Value must be at least 2 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="addressForm.get('state').hasError('maxlength')">
                  <ng-container i18n>Value must be at most 50 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="addressForm.get('state').hasError('allSpaces')">
                  <ng-container i18n>State cannot be spaces alone.</ng-container>
                </mat-error>
              </mat-form-field2>
            </div>
            <div class="col-sm-6">
              <app-country-select
                [nameCtrl]="addressForm.get('country')"
                [codeCtrl]="addressForm.get('country_code')"
              ></app-country-select>
            </div>
            <div class="col-sm-6">
              <mat-form-field2 class="mat-block">
                <input type="text" formControlName="zip" matInput i18n-placeholder placeholder="Postal Code" />
                <mat-error *ngIf="addressForm.get('zip').hasError('minlength')">
                  <ng-container i18n>Value must be at least 2 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="addressForm.get('zip').hasError('maxlength')">
                  <ng-container i18n>Value must be at most 50 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="addressForm.get('zip').hasError('allSpaces')">
                  <ng-container i18n>Postal code cannot be spaces alone.</ng-container>
                </mat-error>
              </mat-form-field2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field2 class="mat-block">
              <input
                type="text"
                formControlName="registration"
                matInput
                i18n-placeholder
                placeholder="Registration Number"
                autocomplete="off"
              />
            </mat-form-field2>
          </div>
          <div class="col-sm-6" *ngIf="isChildUnitRental">
            <mat-form-field2 class="mat-block">
              <input
                type="text"
                formControlName="multi_unit_number"
                matInput
                i18n-placeholder
                placeholder="Unit Number"
                autocomplete="off"
              />
            </mat-form-field2>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-container *ngxPermissionsOnly="'canSeeICalURL'">
  <div class="alert alert-secondary-info mt-3" *ngIf="rental">
    <i class="fal fa-info-circle alert-icon"></i>
    <div class="alert-content">
      <ng-container i18n
        >The iCal URL for this rental is located below for reference. You can use this URL to connect channels that
        support iCal integrations.</ng-container
      >
      <br />
      {{ exportCalendarUrl }}
    </div>
  </div>
</ng-container>
